module.exports = __webpack_public_path__ + "img/Car-Outline.7e1989b3.png";